import { useTranslation } from "react-i18next";
import { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useRecoilValue, useResetRecoilState } from "recoil";
import {
  atomDossier,
  atomSelectedProduct,
  selectorDossierHasProducts,
} from "src/storage";

import "./landing-pv.scss";
import { getProductPathFromCode } from "../products/products_mapping.utils";

export const useLandingPv = () => {
  const { t } = useTranslation();
  const location = useLocation();

  const dossier = useRecoilValue(atomDossier);
  const hasProducts = useRecoilValue(selectorDossierHasProducts);
  const resetSelectedProduct = useResetRecoilState(atomSelectedProduct);

  useEffect(() => {
    if (!hasProducts) {
      resetSelectedProduct();
      localStorage.removeItem("selectedProduct");

      return;
    }
  }, []);

  const navigateToProductPageString = useMemo(() => {
    const productCode = dossier.codProd || "";

    return getProductPathFromCode(productCode);
  }, [dossier?.codProd, location.search]);

  return { hasProducts, navigateToProductPageString, t };
};
